export enum FamilyGuideMeasure {
	NOTHING = "NOTHING",
	LOW = "LOW",
	MEDIUM = "MEDIUM",
	HIGH = "HIGH",
}

export const FamilyGuideMeasureOptions = [
	{
		value: FamilyGuideMeasure.NOTHING,
		label: "هیچ",
		bgColor: "bg-custom-pink/[0.20]",
		color: "text-custom-pink",
	},
	{
		value: FamilyGuideMeasure.LOW,
		label: "کم",
		bgColor: "bg-light-yellow/[0.20]",
		color: "text-light-yellow",
	},
	{
		value: FamilyGuideMeasure.MEDIUM,
		label: "معمولی",
		bgColor: "bg-light-blue/[0.20]",
		color: "text-light-blue",
	},
	{
		value: FamilyGuideMeasure.HIGH,
		label: "زیاد",
		bgColor: "bg-light-lime/[0.20]",
		color: "text-light-lime",
	},
] as const;

export function getFamilyGuideMeasureOption(key: string) {
	const val = (FamilyGuideMeasure as any)[key];
	return FamilyGuideMeasureOptions.find((o) => o.value === val);
}
